import React, { useState } from "react";
import { FaChartPie, FaClock, FaUndo, FaChartLine, FaExpandAlt } from "react-icons/fa";
import "./dashboardcards.css";

const DashboardCards = ({ charts, openFilterForChart, setActiveChart, dashCardData, fullMonth }) => {
  const [activeCard, setActiveCard] = useState(null);

  function formatNumber(num) {
      if (num >= 1_000_000_000) {
          const val = Math.floor(num / 100_000_000) / 10;
          return val + 'B';
      }
      if (num >= 1_000_000) {
          const val = Math.floor(num / 100_000) / 10;
          return val + 'M';
      }
      if (num >= 1_000) {
          const val = Math.floor(num / 100) / 10;
          return val + 'K';
      }
      return num.toString();
  }

  const cards = [
    {
      id: 1,
      title: " Delivered Percentage",
      value: dashCardData.deliveryVsReturnRatio +"%" || 0,
      subtext: "DSR Ratio",
      icon: <FaChartPie size={40} />,
      gradient: "bg-gradient-1",
    },
    // {
    //   id: 2,
    //   title: "Within TAT Delivery",
    //   value: dashCardData.withinTATDelivery +"%" || 0,
    //   subtext: "Within TAT Delivered",
    //   icon: <FaClock size={40} />,
    //   gradient: "bg-gradient-2",
    // },
    {
      id: 2,
      title: "Return Ratio",
      value: dashCardData.returnRatio +"%"  || 0,
      subtext: !dashCardData.returnReason ? 'No Return Shipment' : "Top Return Reason: " + dashCardData.returnReason,
      icon: <FaUndo size={40} />,
      gradient: "bg-gradient-4",
    },
    {
      id: 3,
      title: "COD Amount (Booked)",
      value: formatNumber(dashCardData.businessSummary || 0),
      subtext: "Business Summary",
      icon: <FaChartLine size={40} />,
      gradient: "bg-gradient-3",
    },
  ];

              
  const openModal = (cardId) => {
    setActiveChart(cardId)
    setActiveCard(cardId);
  } 
  const closeModal = () => setActiveCard(null);


  //  onClick={() => {
  //             console.log(card.value);
  //             if(card.value == '0%') {
  //               alert("Data not available.") 
  //             } else { 
  //               openModal(card.id)
  //             }

  //           }}

  return (
    <div>
      <div className="dashboard-cards">
        {cards.map((card, i) => (
          <div
            key={card.id}
            className={`graph-card ${card.gradient}`}
            onClick={() => openModal(card.id)}
          >
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="value">{card.value} <span className="subtext">({fullMonth})</span></div> 

                <div className="card-icon">{card.icon}</div>
            </div>

                <h5>{card.title}</h5>
            <div className="subtext">{card.subtext}</div>

            <div className={`progress-bar-container`} style={{visibility: card.id == 3 ? "hidden" : "block"}}>
              <div
                className="progress-bar-fill"
                style={{
                  width:
                    card.id === 1
                      ? `${dashCardData.deliveryVsReturnRatio || 0}%`
                      // : card.id === 2
                      // ? `${dashCardData.withinTATDelivery || 0}%`
                      : card.id === 2
                      ? `${dashCardData.returnRatio || 0}%`
                      : "100%",
                }}
              ></div>
            </div>

            <div className="expand-hint">
              <FaExpandAlt /> Click to view full chart
            </div>

            <div className="floating-circle"></div>
          </div>
        ))}
      </div>

      {/* Modal for chart */}
      {activeCard && (
        <div className="custom-modal-overlay" onClick={closeModal}>
          <div
            className="custom-modal-content"
            onClick={(e) => e.stopPropagation()}
          >


          {/* <div className="dashboard-header-chart">
            <h2 className="shipment-heading-chart">{cards[activeCard - 1].title}</h2>

            <div className="header-actions">
              <div 
                className="circle-action-button filter" 
                // onClick={() => setShowChartsFilters(!showChartsFilters)}
                title="Toggle Filters"
              >
                <i className="fa fa-filter" />
              </div>
            </div>
          </div> */}


            <div className="dashboard-header-chart">
              {/* <button className="close-btn" onClick={closeModal}>
                &times;
              </button> */}
              <div></div>
              <h4>{cards[activeCard - 1].id == 2 ? cards[activeCard - 1].title : cards[activeCard - 1].subtext}</h4>

              {
                (cards[activeCard - 1].id == 2) ?
                <div className="header-actions">
                  <div 
                    className="circle-action-button filter" 
                    onClick={() => openFilterForChart(cards[activeCard - 1].id)}
                    title="Toggle Filters"
                  >
                    <i className="fa fa-filter" />
                  </div>
                </div>
                : <div></div>
              }
              
            </div>
            <div className="chart-container">{charts[activeCard - 1]}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardCards;
